export default __webpack_public_path__ + "54171557740fb2113ddec88d2eff012b.svg";